import { combineReducers } from 'redux';
import types from './types';

export interface IPaySimpleError {
  hasFailed: boolean;
  message: string;
}

const INITIAL_IS_AUTHORIZED = false;
const INITIAL_IS_PENDING = false;
const INITIAL_ERROR: IPaySimpleError = {
  hasFailed: false,
  message: ''
};
const INITIAL_SHOW_STATUS_MODAL = false;

const authorized = (
  state: boolean = INITIAL_IS_AUTHORIZED,
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.SET_PAYSIMPLE_PAYMENT_IS_AUTHORIZED:
      return payload;

    default:
      return state;
  }
};

const trackingNumber = (
  state: any = {},
  { type, payload }: { type: string; payload: string }
) => {
  switch (type) {
    case types.SET_PAYSIMPLE_PAYMENT_TRACKING_NUMBER:
      return payload;

    default:
      return state;
  }
};

const errorMessage = (
  state: any = {},
  { type, payload }: { type: string; payload: string }
) => {
  switch (type) {
    case types.SET_PAYSIMPLE_PAYMENT_ERROR_MESSAGE:
      return payload;

    default:
      return state;
  }
};

const isPending = (
  state: boolean = INITIAL_IS_PENDING,
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.SET_PAYSIMPLE_PAYMENT_IS_PENDING:
      return payload;

    default:
      return state;
  }
};

const error = (
  state: IPaySimpleError = INITIAL_ERROR,
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.SET_PAYSIMPLE_PAYMENT_ERROR:
      return payload;
    default:
      return state;
  }
};

const showStatusModal = (
  state: boolean = INITIAL_SHOW_STATUS_MODAL,
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.SET_PAYSIMPLE_PAYMENT_SHOW_STATUS_MODAL:
      return payload;

    default:
      return state;
  }
};

const paySimpleReducer = combineReducers({
  authorized,
  trackingNumber,
  errorMessage,
  isPending,
  error,
  showStatusModal
});

export default paySimpleReducer;
